var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-input-base-text',_vm._b({attrs:{"is-invalid":_vm.isInvalid},on:{"input":_vm.inputHandler}},'ui-input-base-text',_vm.model,false))}
var staticRenderFns = []

export { render, staticRenderFns }